
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface Logo {
  id: string;
  name: string;
  url: string;
}

export const useLogos = () => {
  const { data: logos, isLoading } = useQuery({
    queryKey: ["logos"],
    queryFn: async () => {
      // Fetch logos from the database
      const { data: logosData, error } = await supabase
        .from("logos")
        .select("*");
      
      if (error) {
        console.error("Error fetching logos:", error);
        throw error;
      }

      // List all files in the ui_assets bucket to verify what's available
      const { data: storageFiles, error: storageError } = await supabase
        .storage
        .from('ui_assets')
        .list();

      if (storageError) {
        console.error("Error listing storage files:", storageError);
      } else {
        console.log("Available files in storage:", storageFiles);
      }

      return logosData.map((logo: Logo) => ({
        ...logo,
        url: `https://fwbphnqidhvsumeecpjj.supabase.co/storage/v1/object/public/ui_assets/${logo.url}`
      })) as Logo[];
    }
  });

  const getLogoUrl = (name: string) => {
    const logo = logos?.find(logo => logo.name === name);
    if (!logo) {
      console.warn(`Logo with name ${name} not found. Available logos:`, logos);
      return "";
    }
    console.log(`Found logo for ${name}:`, logo);
    return logo.url;
  };

  return { logos, getLogoUrl, isLoading };
};
